import classNames from "classnames";
import tag from "html5-tag";

const renderToolsItem = (e, data) =>
  tag(
    "span",
    {
      class: `ritm-tree__tools-item ${e}`,
      "data-id": data.id,
      "node-type": `tools`,
      "node-action": `${e}`
    },
    ""
  );

export default (node, treeOptions, store) => {
  const { id, name, children, state } = node;
  const droppable = treeOptions.droppable;
  const { depth, open, path, total, selected = false, filtered } = state;
  const childrenLength = children.length;
  const more = !!childrenLength;

  if (filtered === false) return;

  const toggler = tag(
    "span",
    {
      "data-id": id,
      "node-type": "toggler",
      class: classNames(`${treeOptions.togglerClass} el-icon-caret-right`, {
        open: more && open,
        hide: !more
      })
    },
    ""
  );

  const title = tag(
    "span",
    {
      class: "infinite-tree-title",
      "data-id": id,
      "node-type": "title",
      "data-name": name
    },
    name
  );

  const renameInput = tag(
    "input",
    {
      class: "ritm-input tree-node__rename",
      "data-id": id,
      "node-type": "title-input"
    },
    ""
  );

  let inner = store.renameModeNodeId === id ? renameInput : title;
  let dsToolsItems = "";
  let dsToolsBlock = "";
  let dsToolsBlockWrap = "";

  if (store.tools.length) {
    store.tools.forEach(e => (dsToolsItems += renderToolsItem(e, node)));
  }

  let treeNode = tag(
    "div",
    {
      "data-id": id,
      class: "infinite-tree-node",
      style: `padding-left: ${depth * 12}px`
    },
    toggler + inner
  );

  if (dsToolsItems) {
    dsToolsBlockWrap = tag(
      "div",
      { class: "ritm-tree__tools-wrapper", "data-id": id },
      dsToolsItems
    );
    dsToolsBlock = tag("div", { class: "ritm-tree__tools" }, dsToolsBlockWrap);
    treeNode += dsToolsBlock;
  }

  return tag(
    "div",
    {
      draggable: "true",
      "data-id": id,
      "data-expanded": more && open,
      "data-depth": depth,
      "data-path": path,
      "data-selected": selected,
      "data-children": childrenLength,
      "data-total": total,
      class: classNames(`infinite-tree-item`),
      droppable: droppable
    },
    treeNode
  );
};
